import { Skeleton } from "antd";

export default function HotelCardSkeleton() {
  return (
    <div className="flex w-full flex-col overflow-hidden rounded-lg border border-border-minimal bg-background-default shadow-lg md:flex-row">
      {/* Image skeleton */}
      <div className="flex h-60 w-full shrink-0 overflow-hidden md:h-80 md:w-64 lg:h-80 lg:w-80">
        <Skeleton.Image
          active
          className="!h-full !w-full [&_.ant-skeleton-image]:!h-full [&_.ant-skeleton-image]:!w-full [&_.ant-skeleton-image]:!rounded-none"
        />
      </div>

      {/* Content skeleton */}
      <div className="flex flex-1 flex-col gap-4 p-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0 flex-1">
            <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 1, width: "80%" }} />
          </div>
          <div className="hidden shrink-0 sm:block">
            <Skeleton active title={false} paragraph={{ rows: 1, width: 140 }} />
          </div>
        </div>

        <div className="rounded-md border-s-4 border-border-primary bg-background-minimal p-5">
          <div className="border-s-2 border-border-hover ps-4">
            <Skeleton active title={{ width: "50%" }} paragraph={{ rows: 1, width: "70%" }} />
          </div>
          <div className="mt-5 border-s-2 border-border-hover ps-4">
            <Skeleton active title={{ width: "40%" }} paragraph={{ rows: 1, width: "60%" }} />
          </div>
        </div>
      </div>

      {/* Mobile divider */}
      <div className="mx-6 border-t border-dashed border-border-hover md:hidden" />

      {/* Desktop divider */}
      <div className="hidden md:block w-px self-stretch border-l border-dashed border-border-hover" />

      {/* Pricing skeleton */}
      <div className="flex shrink-0 flex-col md:w-72">
        <div className="flex h-full flex-col items-end justify-between p-6 ps-4">
          <div className="w-full border-b border-dashed border-border-hover pb-5">
            <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 2, width: ["40%", "60%"] }} />
          </div>
          <div className="flex flex-col items-end gap-2 pt-4">
            <Skeleton active title={false} paragraph={{ rows: 1, width: 140 }} />
            <Skeleton.Button active style={{ height: 44, width: 120 }} className="[&_.ant-skeleton-button]:!rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
}
